/**
 * 当前支持的语言列表（RFC 1766 规范）
 * 1. 简体中文 zh-cn，繁体中文 zh-tw
 * 2. 其他语言，没有 '-xx' 后缀
 * 3. 与本地语言包的文件名一致（对应 i18n 中的 locale 属性值）
 */
export const LangList = [
    'zh-cn',
    'zh-tw',
    'en',
    'ja', // 日本
    'ko', // 韩国
    'pt', // 葡萄牙
    'th', // 泰国
    'id', // 印尼
    'it', // 意大利
    'fr', // 法国
    'de', // 德国
];

/**
 * @description Tencent LI 支持的语言列表（大小写敏感）
 * @see https://docs.playernetwork.intlgame.com/docs/zh/API/Web/LIPWebSDK/LIPConfig/#ParameterConfig
 */
export const TencentLangList = [
    'en',
    'zh-Hans',
    'ja',
    'de',
    'fr',
    'es',
    'pt',
    'id',
    'th',
    'ru',
    'zh-HK',
    'zh-TW',
    'ar',
    'ko',
    'tr',
    'it',
];
